export const getSplitGroupOptions = (item: {
  groupOptions:
    | {
        label: string
        value: string
      }[]
    | undefined
}) => {
  const timeframes = new Set<string>()
  const aggregations = new Set<string>()

  if (!item.groupOptions) {
    return {
      timeframes: new Set<string>(),
      aggregations: new Set<string>(),
    }
  }

  // Split the group options into timeframes and aggregations based on their labels
  item.groupOptions.forEach((option) => {
    // Special cases
    if (option.label === "Latest") {
      timeframes.add("Latest")
      return
    }
    if (option.label === "ATH" || option.label === "ATL") {
      aggregations.add(option.label)
      return
    }

    // Regular pattern: "24h avg" -> 24h is timeframe, avg is aggregation
    const [timeframe, aggregation] = option.label.split(" ")

    if (timeframe && aggregation) {
      timeframes.add(timeframe)
      aggregations.add(aggregation)
    }
  })

  return { timeframes, aggregations }
}

export const getGroupOptionFromTimeframeAndAggregation = (
  timeframe: string,
  aggregation: string,
  groupOptions:
    | {
        label: string
        value: string
      }[]
    | undefined
) => {
  if (!groupOptions) {
    return null
  }

  const combinedLabel = [timeframe, aggregation].filter(Boolean).join(" ")
  const foundOption = groupOptions.find(
    (option) => option.label === combinedLabel
  )

  if (!foundOption) {
    return null
  }

  return foundOption
}

export const getGroupOptionFromValue = (
  value: string | undefined,
  groupOptions:
    | {
        label: string
        value: string
      }[]
    | undefined
) => {
  if (!value || !groupOptions) {
    return null
  }

  return groupOptions.find((option) => option.value === value)
}

export const getAggregationAndTimeframeFromValue = (
  value: string | undefined,
  groupOptions: {
    label: string
    value: string
  }[]
): { aggregation: string; timeframe: string } | null => {
  const foundOption = groupOptions.find((option) => option.value === value)

  if (!foundOption) {
    return null
  }

  if (foundOption.label === "Latest") {
    return { aggregation: "", timeframe: "Latest" }
  }
  if (foundOption.label === "ATH") {
    return { aggregation: "ATH", timeframe: "" }
  }
  if (foundOption.label === "ATL") {
    return { aggregation: "ATL", timeframe: "" }
  }

  const [timeframe, aggregation] = foundOption.label.split(" ")

  if (!timeframe || !aggregation) {
    return null
  }

  return {
    aggregation,
    timeframe,
  }
}
